
export const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);

    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    const blob = new Blob(byteArrays, { type: contentType });
};

export const bufferToFile = (buffer, mime) => {
    const byteCharacters = buffer;
    var sliceSize = 1024;
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    console.log({ byteArrays });
    const blob = new Blob(byteArrays, { type: mime });
    console.log({blob});
    const newFile = new File([blob], 'fileName.jpg', {
        type: mime,
        lastModified: Date.now(),
    });
    return newFile;
};

export const dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
};

const readFileAsync = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
        resolve(event.target.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
});

const loadImageAsync = (targetResult) => new Promise((resolve, reject) => {
    console.log({ targetResult });
    const img = new Image();
    img.src = targetResult;
    img.onload = () => {
        resolve(img);
    };
    img.onerror = reject;
});
const canvasToBlob = (ctx, type, quality = 0.7) => new Promise((resolve) => {
    /* ctx.drawImage(img, 0, 0, width, height); */
    const imgQuality = (quality !== undefined) ? quality : 0.7;
    ctx.canvas.toBlob((blob) => {
        resolve(blob);
    }, type, imgQuality);
});
const getMime = (base64String) => {
    return base64String.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
}


/*
  * Exports ⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇
 */
export const resizeImage = async (uri, maxWidth, type, fileName) => {

    const blobFile = dataURItoBlob(uri);
    console.log({ blobFile });
    try {
        const targetResult = await readFileAsync(blobFile);
        try {
            const img = await loadImageAsync(targetResult);
            const originalWidth = img.width;
            let scaleFactor = 1;
            if (originalWidth > maxWidth) {
                scaleFactor = maxWidth / originalWidth;
            }
            const elem = document.createElement('canvas');
            elem.width = img.width * scaleFactor;
            elem.height = img.height * scaleFactor;
            const ctx = elem.getContext('2d');
            ctx.drawImage(img, 0, 0, img.width * scaleFactor, img.height * scaleFactor);

            try {
                const newBlob = await canvasToBlob(ctx, type, 0.7);
                const newFile = new File([newBlob], fileName, {
                    type: getMime(uri),
                    lastModified: Date.now(),
                });
                let output = null
                const reader = new FileReader();
                return new Promise((resolve, reject) => {
                    reader.onloadend = async () => {
                        if (reader.result) {
                            output = reader.result
                            resolve(output)
                        }
                    };
                    reader.readAsDataURL(newFile);
                })
            } catch (e) {
                console.log(e);
                return null
            }
        } catch (e) {
            console.log(e, 'erro ao tentar carregar imagem a partir do arquivo');
            return null
        }
    } catch (e) {
        console.log('erro ao tentar ler o arquivo', e);
        return null
    }
};
